import { render } from "./listResults.vue?vue&type=template&id=8481e964&ts=true"
import script from "./listResults.vue?vue&type=script&lang=ts"
export * from "./listResults.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__